import script from "./UserSearchBar.vue?vue&type=script&lang=ts&setup=true"
export * from "./UserSearchBar.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__